export default __webpack_public_path__ + "static/media/python3c.d26fa8a8.png";